import { render, staticRenderFns } from "./orderSummary.vue?vue&type=template&id=459c36b2&"
import script from "./orderSummary.vue?vue&type=script&lang=js&"
export * from "./orderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports